import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { Button, FlexContainer, SingleCardPage } from '@act/storybook';
import { authService } from 'redux/utils/auth/authService';
import useIsAuthenticated from 'redux/utils/auth/isAuthenticatedHook';

/**
 * Google login for the reports subdomain; redirects to the report list on success.
 */
const ReportsLoginPage = () => {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <SingleCardPage showReemaLogo={true}>
      <Typography variant="headlineLarge" align="center">
        Customer Reports
      </Typography>
      <Typography variant="bodyLarge" align="center">
        Sign in to open the report builder.
      </Typography>
      <FlexContainer direction="row" justifyContent="center" margin="16px 0 0">
        <Button
          variant="outlined"
          debounced
          trackingName="reports-login-google"
          onClick={() => {
            void authService.login('/');
          }}
        >
          Continue with Google
        </Button>
      </FlexContainer>
    </SingleCardPage>
  );
};

export default ReportsLoginPage;
